module.exports = __webpack_public_path__ + "static/media/user-placeholder.4b4d70ff.png";